import React, { useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Container, Button, Box, Typography } from '@mui/material';
import { validateToken } from './utilities/validateToken';

const Home = () => {
    const [title, setTitle] = useState('Payment')
    const navigate = useNavigate();


    useEffect(() =>{
        const hostname = window.location.hostname;

        if (hostname === 'localhost') {
            setTitle('Payment Test')
        } else if (hostname === 'paymentstest.leviton.com') {
            setTitle('Payment Test')
        } else {
            setTitle('Payment')
        }

        const checkAuthentication = async () => {
            const token = localStorage.getItem('authToken');

            if(!token) {
                navigate('/login');
                return;
            }

            //Validate the token, using utility function
            const isValid = await validateToken(token);
            if (!isValid) {
                localStorage.removeItem('authToken')
                navigate('/login')
            }

        };

        checkAuthentication();
    }, [navigate])

    return (
        <Container>
            <Box sx= {{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                <Typography variant="h4" component='h1' gutterBottom>
                    Leviton {title}
                </Typography>
                <Link to='/createpayment' style={{ textDecoration: 'none'}}>
                    <Button
                        variant='contained'
                        color='primary'
                        style={{backgroundColor: '#76b900'}}
                        // startIcon={<AttachMoneyIcon/>}
                        sx={{ fontSize: '1.5rem', padding: '10px 20px' }}
                    >
                        Create a Payment
                    </Button>
                </Link>
            </Box>
        </Container>
    )
}

export default Home;